import Appsignal from "@appsignal/javascript";

const appsignal = new Appsignal({
  key: import.meta.env.APPSIGNAL_FE_KEY,
  revision: import.meta.env.APP_REVISION,
});
export default appsignal;
